<rk-fold-item [name]="'MEDIA.FILTERS.PLAYLIST_INPUT.HEADER' | translate">
  <ng-container [formGroup]="playlistForm">
    <div class="top">
      <mat-checkbox formControlName="yes">{{
        'MEDIA.FILTERS.PLAYLIST_INPUT.YES' | translate
      }}</mat-checkbox>
    </div>
    <div>
      <mat-checkbox formControlName="no">{{
        'MEDIA.FILTERS.PLAYLIST_INPUT.NO' | translate
      }}</mat-checkbox>
    </div>
  </ng-container>
</rk-fold-item>
